import styled from 'styled-components';

export const Title = styled.div`
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    font-weight: 900;
    font-size: 20px;
    color: ${(props) => props.color};
    margin: 0;
  }
`;

export const ErrorMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  color: #b91c1c;
  border-radius: 8px;
  background-color: #fee2e2;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 12px;
  margin-top: -6px;
  padding: 4px;
  box-sizing: border-box;

  svg {
    width: 48px;
    height: 48px;
  }

  @media (max-width: 1000px) {
    margin-bottom: 0px !important;
    padding: 16px;

    svg {
      width: 100px;
    }
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(184, 184, 184, 1) 50%,
    rgba(77, 77, 77, 0.4990371148459384) 100%
  );
  z-index: 99999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContainerModalItems = styled.div`
  position: relative;
  min-height: calc(50% - 25px);

  width: 848px;
  margin: auto;
  background-color: #ffffff;
  z-index: 9999999;
  box-shadow: 0px 0px 10px #4d4d4d;
  border-radius: 10px;
  padding: 16px 24px;
  box-sizing: border-box;

  span,
  p,
  h2,
  input {
    color: #4d4d4d;
  }

  .container-body {
    display: flex;
    box-sizing: border-box;
    flex-flow: column;
    gap: 16px;
    width: 100%;

    .container-main {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      gap: 16px;

      .pix-value-container {
        min-width: 388px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .parcel {
          padding: 16px;
          border-radius: 4px;
          background-color: #f6f6f6;
          width: 100%;

          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: -webkit-fill-available;
          height: -moz-available;
          width: fill-available;

          box-sizing: border-box;

          .parcels-selected-text {
            font-size: 18px;
            font-weight: bold;
            line-height: 28px;
            display: block;
          }

          .parcels-quantity-text {
            font-size: 16px;
            line-height: 24px;
            display: block;
            margin-top: 4px;
            margin-bottom: 8px;
          }

          p {
            bottom: 0;
            font-size: 12px;
            line-height: 18px;
            margin: 0;
          }
        }

        .values-container {
          height: fit-content;
          padding: 8px 16px;
          border-radius: 4px;
          bottom: 0;
          background-color: #f6f6f6;
          width: 100%;
          box-sizing: border-box;

          .values {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            span {
              font-size: 12px;
              color: #848484;
              text-align: center;
              display: block;

              &:not(.value) {
                padding: 8px;
                border-bottom: 1px solid #d1d1d1;
                width: 100%;
              }
            }

            .value {
              margin-top: 2px;
            }
          }
          .total-value {
            margin-top: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            .label {
              font-size: 16px;
              font-weight: bold;
              line-height: 24px;
              margin-right: 8px;
            }
            .value {
              font-size: 18px;
              font-weight: 700;
              line-height: 28px;
              color: ${(props) => props.color};
            }
          }

          .hasValue {
            color: #4d4d4d !important;
            .value {
              font-weight: bold;
              color: #4d4d4d !important;
            }
          }
        }
      }
    }
    .pix-code-container {
      height: 412px;
      padding: 16px;
      border-radius: 4px;
      display: flex;

      background-color: #f6f6f6;
      box-sizing: border-box;
      position: relative;

      .generate-pix-code {
        background-color: #fff;
        position: absolute;
        width: calc(100% - 32px);
        box-sizing: border-box;
        z-index: 1;
        margin: auto;

        padding: 24px 16px;
        border-radius: 8px;
        box-shadow: 0px 2px 4px -2px rgba(77, 77, 77, 0.06),
          0px 4px 8px -2px rgba(77, 77, 77, 0.1);

        h2 {
          font-size: 20px;
          color: ${(props) => props.color};
          text-align: center;
          margin: 0;
        }

        p {
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          margin-top: 8px;
          margin-bottom: 24px;
        }
      }

      .code-generated {
        display: flex;
        flex-flow: column;
        align-items: center;

        text-align: center;

        &.isHidden {
          filter: blur(8px);

          pointer-events: none;
          user-select: none;
        }

        h2 {
          margin: 0;
          margin-bottom: 8px;
          font-size: 18px;
        }

        p {
          margin: 16px auto;
          font-size: 16px;

          line-height: 24px;
          text-align: center;
        }

        .input-code {
          width: 100%;
          padding: 8px 16px;
          box-sizing: border-box;
          margin-bottom: 16px;
          border-radius: 4px;
          border: 1px solid #848484;
          height: 40px;
        }

        img {
          height: 160px;
        }
      }
    }
  }

  .important-infos-container {
    background-color: #f6f6f6;
    padding: 8px 16px;
    border-radius: 4px;

    .title {
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
    }

    div {
      margin-top: 4px;
      span {
        font-size: 14px;
        display: block;
        line-height: 20px;
      }
    }
  }

  @media (max-width: 1000px) {
    width: 99vw;
    height: 99vh;

    .container-body {
      height: calc(100% - 48px);
      box-sizing: border-box;
      overflow: auto;
      .container-main {
        flex-direction: column;

        .pix-value-container {
          min-width: auto;

          .parcel {
            height: auto;
          }
          .values-container {
            height: auto;

            .values {
              display: grid;
              grid-template-columns: 1fr;
              span {
                text-align: left;
              }

              .value {
                display: inline;
              }
            }

            .total-value {
              text-align: left;
              margin-left: 8px;
              justify-content: flex-start;
            }
          }
        }

        .pix-code-container {
          height: auto;
        }
      }
    }
  }
`;
